module.exports = __webpack_public_path__ + "static/sp_silo_full-6d943ec8b9d9b4a718b2d8ed8c6330ae.jpg";